import {AuthStore} from "@/hooks/stores/AuthStore"
// import { useUserProfile } from '@/hooks/stores/userStore';
// import { useAuthUserId } from '@/hooks/stores/AuthStore';

// Mock data structure (for fallback or additional data)
const mockAcademicPerformance = {
  subjects: [
    { name: 'Mathematics', grade: 'A', progress: 85 },
    { name: 'English', grade: 'B+', progress: 78 },
    { name: 'Science', grade: 'A-', progress: 82 },
    { name: 'History', grade: 'B', progress: 75 },
    { name: 'Art', grade: 'A', progress: 90 },
  ],
  overallAverage: 82,
  attendanceRate: 95,
  studyHours: 25,
};

const mockGoals = [
  { id: '1', title: 'Complete Algebra Course', deadline: '2024-12-31', progress: 60 },
  { id: '2', title: 'Read 5 Books', deadline: '2024-11-30', progress: 80 },
  { id: '3', title: 'Improve Writing Skills', deadline: '2024-12-15', progress: 40 },
];

const mockAchievements = [
  { id: '1', title: 'Perfect Attendance', description: '30 days streak', icon: '🏆', date: '2024-10-15' },
  { id: '2', title: 'Math Master', description: 'Scored 100% in Algebra', icon: '🎯', date: '2024-10-10' },
  { id: '3', title: 'Fast Learner', description: 'Completed 5 courses in a week', icon: '⚡', date: '2024-10-05' },
  { id: '4', title: 'Team Player', description: 'Helped 10 classmates', icon: '🤝', date: '2024-09-28' },
];

const mockCareerPaths = [
  { id: '1', title: 'Software Engineering', match: 95, description: 'High demand career with great growth potential' },
  { id: '2', title: 'Data Science', match: 88, description: 'Analyze data to drive business decisions' },
  { id: '3', title: 'Cybersecurity', match: 82, description: 'Protect systems and data from threats' },
  { id: '4', title: 'UX Design', match: 75, description: 'Design user-friendly digital experiences' },
];

const mockWeeklyProgress = [
  { day: 'Mon', hours: 3 },
  { day: 'Tue', hours: 4 },
  { day: 'Wed', hours: 2 },
  { day: 'Thu', hours: 5 },
  { day: 'Fri', hours: 3 },
  { day: 'Sat', hours: 2 },
  { day: 'Sun', hours: 1 },
];

export const useUserData = () => {
  const currentUser = AuthStore((state) => state.currentUser);
  const hasHydrated = AuthStore((state) => state._hasHydrated);
  // const userId = useAuthUserId();
  
  // If no user profile exists, create a minimal fallback
  const fallbackUser = {
    name: 'Student',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/svg?seed=student',
    totalPoints: 0,
    tasksCompleted: 0,
    streakDays: 0,
    level: 1,
    grade: 'Grade 10',
    email: 'student@example.com',
    joinDate: new Date(),
    rank: 0,
    preferences: {
      notifications: true,
      soundEffects: false,
      theme: 'light',
      language: 'en',
      timezone: 'Africa/Lagos',
      notificationSettings: {
        email: true,
        push: true,
        sms: false,
      },
    },
  };
  
  // Use real user data if available, otherwise fallback
  // const user = userProfile ? {
  //   name: userProfile.name,
  //   avatarUrl: userProfile.avatarUrl || fallbackUser.avatarUrl,
  //   totalPoints: userProfile.totalPoints || fallbackUser.totalPoints,
  //   tasksCompleted: userProfile.tasksCompleted || fallbackUser.tasksCompleted,
  //   streakDays: userProfile.streakDays || fallbackUser.streakDays,
  //   level: userProfile.level || fallbackUser.level,
  //   grade: userProfile.grade || fallbackUser.grade,
  //   email: userProfile.email || fallbackUser.email,
  //   joinDate: userProfile.joinDate || fallbackUser.joinDate,
  //   rank: userProfile.rank || fallbackUser.rank,
  //   preferences: userProfile.preferences || fallbackUser.preferences,
  // } : fallbackUser;

  const user = currentUser ? {
    ...fallbackUser,
    ...currentUser,
  } : fallbackUser
  
  return {
    user,
    goals: mockGoals,
    achievements: mockAchievements,
    weeklyProgress: mockWeeklyProgress,
    academicPerformance: mockAcademicPerformance,
    careerPaths: mockCareerPaths,
    isLoading: !hasHydrated // Loading if userId exists but no profile
  };
};